import { AText, Box } from '@alf/uikit';
import { Image } from '@namespace/icons2';

import styles from './index.module.css';

const EmptyBonusList = ({ title = '', className = '' }) => {
  return (
    <Box
      direction="column"
      justify="center"
      align="center"
      className={`${styles.wrap} ${className}`}
    >
      <Image name="general/bonus" className={styles.icon} alt={title} />
      <AText breed="RU" size="m" color="po_txt_color_3" className={styles.text}>
        {title}
      </AText>
    </Box>
  );
};

export default EmptyBonusList;
